import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'
import { visibleSettings } from '@/components/settings/sections'
import { cn } from '@/lib/utils'

export const Route = createFileRoute('/_app/settings')({ component: SettingsLayout })

function SettingsLayout() {
  const { me } = Route.useRouteContext()
  const pathname = useRouterState({ select: (s) => s.location.pathname })
  const atIndex = pathname === '/settings' || pathname === '/settings/'
  const items = visibleSettings(me)

  return (
    <div className="grid gap-6 lg:grid-cols-[15rem_minmax(0,1fr)] lg:gap-10">
      <nav aria-label="Settings" className={cn('hidden lg:block', atIndex && 'lg:block')}>
        <h1 className="mb-4 text-2xl font-semibold">Settings</h1>
        <ul className="grid gap-0.5">
          {items.map((s) => {
            const active = pathname.startsWith(`/settings/${s.slug}`)
            return (
              <li key={s.slug}>
                <Link
                  to="/settings/$slug"
                  params={{ slug: s.slug }}
                  aria-current={active ? 'page' : undefined}
                  className={cn(
                    'flex items-center gap-2.5 rounded-md px-3 py-2 text-[14px] font-medium text-muted-foreground hover:bg-secondary hover:text-foreground',
                    active && 'bg-secondary text-foreground',
                  )}
                >
                  <s.icon className="size-4 shrink-0" aria-hidden />
                  {s.title}
                </Link>
              </li>
            )
          })}
        </ul>
      </nav>
      <div className="min-w-0">
        {!atIndex && (
          <Link
            to="/settings"
            className="mb-3 inline-flex items-center gap-1 text-sm font-medium text-muted-foreground hover:text-foreground lg:hidden"
          >
            <ChevronLeft className="size-4" aria-hidden />
            Settings
          </Link>
        )}
        <Outlet />
      </div>
    </div>
  )
}
